import { render, staticRenderFns } from "./TeacherPageDetailsModal.vue?vue&type=template&id=55f2a834&scoped=true&"
import script from "./TeacherPageDetailsModal.vue?vue&type=script&lang=js&"
export * from "./TeacherPageDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f2a834",
  null
  
)

export default component.exports